module.exports = __webpack_public_path__ + "media/theme/logo_final-dcd52de1.svg";